import img from './assets/partners-and-investors.png'
import { SectionHeading } from './SectionHeading'

/**
 * The investor wall, as a picture and nothing else.
 *
 * It used to carry fourteen absolutely-positioned anchors laid over the artwork, each one a
 * hand-measured `cqi` rectangle meant to sit on top of a logo. Four of them had no `href` at all,
 * so they were transparent boxes that swallowed the cursor; the rest were positioned against a
 * `container-inline-size` class this Tailwind build does not emit, so the units they were measured
 * in never resolved the way the measurements assumed and the boxes did not land on the logos.
 *
 * There is no version of that worth repairing — the logos are baked into a single flat PNG, so any
 * hit map is a set of magic numbers that silently rots the next time the image is re-exported.
 *
 * The image is also no longer capped at 65% on a phone, which was rendering nineteen logos into
 * about 240px.
 */
export function PartnersAndInvestors() {
    return (
        <div id='partners' className='flex flex-col py-8'>
            <SectionHeading className='pb-6'>PARTNERS &amp; INVESTORS</SectionHeading>
            <img
                src={img}
                width={1803}
                height={828}
                alt='6th Man Ventures, Solana Ventures, Shima Capital, Big Brain Holdings, GOAT Capital, Infinity Ventures Crypto, Krafton, Ryze Labs, Justin Kan, YGG SEA, Magic Eden, Aptos, Degen Legends and Community Gaming'
                className='mx-auto h-auto w-[calc(100%-2rem)] md:w-[65%]'
            />
        </div>
    )
}
